import { useTranslation } from "react-i18next";
import Logo from "../../../components/feature/Logo";

const FOOTER_GROUPS: { groupKey: string; linkCount: number }[] = [];

export default function Footer() {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#111111] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="border-t border-white/10 pt-8 flex justify-center">
          <p className="text-white/25 text-xs">© {new Date().getFullYear()} Forward Company., LTD. All rights reserved.</p>
        </div>
      </div>

      <div className="bg-[#C8953A]/5 border-t border-[#C8953A]/10 py-4">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-white/30 text-xs tracking-wide">{t("ft.tagline")}</p>
          <button onClick={() => scrollTo("home")} className="whitespace-nowrap flex items-center gap-2 text-[#C8953A]/60 hover:text-[#C8953A] text-xs transition-colors duration-200 cursor-pointer">
            <i className="ri-arrow-up-line" />
            {t("ft.backtop")}
          </button>
        </div>
      </div>
    </footer>
  );
}
